import Bowser from 'bowser';
import { useMemo } from 'react';
import { useIsClient } from 'usehooks-ts';

type SystemType =
  | 'Mac Apple Chip'
  | 'Mac Intel Chip'
  | 'Windows 64-bit'
  | 'Linux'
  | 'Unknown';

export const useSystemInfo = (): SystemType => {
  const isClient = useIsClient();

  const systemInfo = useMemo(() => {
    if (!isClient) {
      return 'Unknown';
    }

    const browser = Bowser.getParser(window.navigator.userAgent);
    const osName = browser.getOSName(true);

    if (osName === 'macos') {
      const isAppleSilicon = /ARM64|aarch64/.test(window.navigator.userAgent);
      return isAppleSilicon ? 'Mac Apple Chip' : 'Mac Intel Chip';
    }

    if (osName === 'windows') return 'Windows 64-bit';
    if (osName === 'linux') return 'Linux';
    return 'Unknown';
  }, [isClient]);

  return systemInfo;
};
